import { useAnimations, useGLTF } from '@react-three/drei'
import React, { JSXElementConstructor, ReactElement, useEffect, useState } from 'react'
import { GLTF } from 'three-stdlib'
import { useObjectInstance, useUUID } from '../../e.elements/GameElements/GameElement/GameElement'
import { useSceneStore } from '../../a.scenes/GameScene/store'
import useTruthyEffect from '../../utils/hooks/useTruthyEffect'

const URL = process.env.PUBLIC_URL + '/assets/characters/KayKit_AnimatedCharacter_v1.2.glb'

type GLTFResult = GLTF & {
  nodes: {
    PrototypePete: THREE.SkinnedMesh
    Body: THREE.Bone
  }
  materials: {
    PrototypePete: THREE.MeshStandardMaterial
  }
}

type ActionName =
  | 'Attack(1h)'
  | 'AttackCombo'
  | 'AttackSpinning'
  | 'BasePose'
  | 'Block'
  | 'Cheer'
  | 'Climbing'
  | 'Dance'
  | 'DashBack'
  | 'DashFront'
  | 'DashLeft'
  | 'DashRight'
  | 'Defeat'
  | 'HeavyAttack'
  | 'Hop'
  | 'Idle'
  | 'Interact'
  | 'Jump'
  | 'LayingDownIdle'
  | 'PickUp'
  | 'Roll'
  | 'Run'
  | 'Shoot(1h)'
  | 'Shoot(2h)'
  | 'Shoot(2h)Bow'
  | 'Shooting(1h)'
  | 'Shooting(2h)'
  | 'Throw'
  | 'Walk'
  | 'Wave'
export type GLTFActions = Record<ActionName, THREE.AnimationAction>

type CharacterProps = {
  children: ReactElement<any, string | JSXElementConstructor<any>>
}

const CharactersAnimations = ({ children }: CharacterProps) => {
  const [enhancedChildren, setEnhancedChildren] = useState<any>()
  const uuid = useUUID()
  const obj = useObjectInstance()
  const addGameElementsAnimationActions = useSceneStore(s => s.addGameElementsAnimationActions)

  const { nodes: nodesSrc, animations } = useGLTF(URL) as GLTFResult

  const { actions } = useAnimations(animations, obj)

  useTruthyEffect(() => {
    addGameElementsAnimationActions(uuid!, actions as GLTFActions)
  }, [uuid, actions, obj])

  useEffect(() => {
    if(children && !enhancedChildren) {
      setEnhancedChildren(
        React.cloneElement(children, { key: `${uuid}_anim`, nodesSrc, ...children.props })
      )
    }
  },[children, enhancedChildren])

  return React.cloneElement(children, { key: `${uuid}_anim`, nodesSrc, ...children.props })
  // return <MemoChildren>{enhancedChildren}</MemoChildren>
}

export default CharactersAnimations

useGLTF.preload(URL)

const MemoChildren = React.memo(({ children }: { children: any }) => {
  return <>{children}</>
})
